import { cn } from "@omni/utils/styles";

import { Anchor } from "@/components/General/Anchor/anchor.component";
import { FlyoutCategory } from "@/redux/modules/value/flyoutCategories/flyoutCategories.types";

type Props = {
    category: FlyoutCategory;
    className?: string;
};

export const CategoryAnchor = ({ category, className }: Props) => {
    return (
        <Anchor
            color={"link"}
            href={category.url}
            fullWidth={true}
            className={cn(
                "tw:py-2 tw:px-4 tw:text-left tw:border-b tw:border-grey-light tw:rounded-none!",
                className
            )}
        >
            {category.title}
        </Anchor>
    );
};
